module.exports = __webpack_public_path__ + "img/ep-coquillage.087f5d15.jpg";